import script from "./shangcaixq.vue?vue&type=script&setup=true&lang=js"
export * from "./shangcaixq.vue?vue&type=script&setup=true&lang=js"

import "./shangcaixq.vue?vue&type=style&index=0&id=68282e31&lang=less&scoped=true"
script.__scopeId = "data-v-68282e31"

export default script